
import { observer } from "mobx-react";
import SocketStore from "../../stores/SocketStore";
import './index.css';
import { useEffect } from "react";
import DOMPurify from 'dompurify';
import { DomPurifyHtml } from "../DomPurifyHtml";


const ColorPicker = ({ isColorPickerOpen }) => {

  const mainColors = [
    {
      color: '#7A63FF',
      key: '#7A63FF',
      render: () => <DomPurifyHtml
        html={`
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z" fill="#7A63FF" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `}
        className="color-picker-main-color-item-icon"
      />
    },
    {
      color: '#FF0000',
      key: '#FF0000',
      render: () => <DomPurifyHtml
        html={`
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z" fill="#FF0000" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `}
        className="color-picker-main-color-item-icon"
      />
    },
    {
      color: '#00FF51',
      key: '#00FF51',
      render: () => <DomPurifyHtml
        html={`
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z" fill="#00FF51" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `}
        className="color-picker-main-color-item-icon"
      />
    },
    {
      color: '#F2FF00',
      key: '#F2FF00',
      render: () => <DomPurifyHtml
        html={`
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5Z" fill="#F2FF00" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
                  `}
        className="color-picker-main-color-item-icon"
      />
    }]


  useEffect(() => {
    SocketStore.setSelectedShapeColor(mainColors[0].key);
  }, []);

  const selectedColor = SocketStore.selectedShapeColor;

  if (!isColorPickerOpen) return null;

  return (
    <div className={`color-picker-container`}>
      <div className="color-picker-main-colors" >
        {mainColors.map((color) => (
          <div key={color.key} className="color-picker-main-color-item" onClick={() => {
            SocketStore.setSelectedShapeColor(color.key);
          }}
            style={color.key === selectedColor ? {
              backgroundColor: 'var(--background-main)',
            } : {}}
          >
            {color.render()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(ColorPicker);